<hpo-content-layout [useAnchors]="true"
    [mobile]="mobile"
    [toolbarTemplate]="!printState ? detailsToolbar : null"
    (scrolling)="scrolling($event)">

    <div class="instruction"
        [class.instruction--mobile]="mobile">

        <ng-container *ngIf="instruction">

            <h1 *ngIf="printState !== 'item'"
                class="instruction__title">

                {{instruction.attributes.name}}

                <a routerLink="."
                    fragment="">
                    <mat-icon matTooltip="{{ 'default.copyLink' | blah }}"
                        matTooltipClass="hpo"
                        (click)="copyLink()">link</mat-icon>
                </a>

                <a (click)="openPrintDialog()">
                    <mat-icon>print</mat-icon>
                </a>

                <app-favorites [instruction]="instruction"></app-favorites>

            </h1>

            <a *ngIf="changelogEntries && changelogEntries.length > 0"
                class="instruction__changelog"
                (click)="showChangelog()">
                {{ 'default.changelogInstruction' | blah }}
            </a>

            <div class="instruction__details">
                <ul class="tags"
                    [ngClass]="{'tags-mobile': ff_addInstructionsToIwm && instruction.inIframe}">
                    <li *ngFor="let tag of instruction.tags">
                        <a [routerLink]="['/catalog/headpower']"
                            [queryParams]="{ id: tag.attributes.drupal_internal__revision_id, name: tag.attributes.name }">
                            {{tag.attributes.name}}
                        </a>
                    </li>
                </ul>

                <a *ngIf="ff_addInstructionsToIwm && instruction.inIframe && instruction.openedFrom !== 'IWS'"
                    class="add-instruction-to-iwm-btn"
                    [id]="'add-instruction-to-iwm-btn-' + instruction.id"
                    mat-stroked-button
                    color="primary"
                    (click)="addInstructionToIWM($event)">
                    <mat-icon inline=true>add</mat-icon>
                    {{ 'default.addInstructionToIwm' | blah }}
                </a>
            </div>
        </ng-container>

        <ng-container *ngIf="loading">
            <hpo-placeholder type="row"></hpo-placeholder>
            <hpo-placeholder type="row"></hpo-placeholder>
            <hpo-placeholder type="row"></hpo-placeholder>
        </ng-container>

        <ng-template appHost></ng-template>

        <app-copyright></app-copyright>

    </div>

</hpo-content-layout>

<div class="print-note"
    [class.printing]="printState">

    <h4 *ngIf="printState">
        {{ 'default.printing' | blah }}...
    </h4>

    <h4 *ngIf="!printState">
        {{ 'default.useInstructionPrintButton' | blah }}
    </h4>

</div>

<ng-template #detailsToolbar>
    <div class="iwi-details-toolbar__container"
        [ngClass]="{'desktop': !mobile}">
        <div></div>
        <app-instruction-search [mobile]="mobile"></app-instruction-search>
    </div>
</ng-template>